import { Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { PuebloInfoPage } from '../pueblo-info/pueblo-info';
import { PuebloMenuPage } from '../pueblo-menu/pueblo-menu';
import { ListaCategorias } from '../lista-categorias/lista-categorias';
import { Pueblo } from '../../models/pueblo.model';
import { BuscadorPage } from '../buscador/buscador';

/**
 * Generated class for the PuebloTabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pueblo-tabs',
  templateUrl: 'pueblo-tabs.html',
})
export class PuebloTabsPage {
  public puebloinfo= PuebloInfoPage;
  public pueblomenu= PuebloMenuPage;
  public listacategorias= ListaCategorias;
  public pueblo:Pueblo;

  constructor(public navCtrl: NavController, public navParams: NavParams,public menuCtrl:MenuController) {
    this.pueblo =  this.navParams.get("pueblo");
  }
  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad PuebloTabsPage');
  }
  toggleMenu() {
    this.menuCtrl.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pueblo-tabs/pueblo-tabs.ts